import config from "../config";
import dispatcher from "../dispatcher";
import pageLoadStore from "./page-load.store";

var loaded = false;
var minTimeout = 10; // 300;
var deferTimeout = 1500;
var complete = false;

var _handleStore = function () {
  var storeData = pageLoadStore.getData();
  var pageWrapper;

  if (complete === storeData.loaded) return;
  complete = storeData.loaded;

  pageWrapper = document.getElementsByClassName("page-wrapper")[0];

  if (complete) {
    pageWrapper.classList.add("load-complete");
    pageWrapper.classList.add("load-complete-once");

    setTimeout(function () {
      pageWrapper.classList.add("load-complete-temedout");
    }, deferTimeout);
    color();
  } else {
    pageWrapper.classList.remove("load-complete");
  }
};

const color = function () {
  const body = document.querySelector(".page-wrapper");
  const page = window.location.pathname;
  setTimeout(() => {
    if (page.indexOf("index") > -1 || page === "/") {
      body.classList.add("white-logo");
      const banner = document.querySelector(".cookie-banner");
      if (banner) banner.style.border = "2px solid transparent";
    } else {
      body.classList.remove("white-logo");
      const banner = document.querySelector(".cookie-banner");
      if (banner) banner.style.border = "2px solid";
    }
  }, 300);
};

var init = function () {
  pageLoadStore.subscribe(_handleStore);

  setTimeout(function () {
    var preloader = document.getElementsByClassName("preloader-full")[0];
    var initPreloader = document.getElementById("init-preloader");
    if (preloader && !config.dev) return;

    if (initPreloader) {
      initPreloader.classList.remove("start");
      initPreloader.classList.add("end");

      setTimeout(function () {
        initPreloader.parentNode.removeChild(initPreloader);
      }, 1000);
    }

    dispatcher.dispatch({
      type: "page-load:load",
    });
  }, minTimeout);
};

export default {
  init: init,
};
